"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CACHE_KEY = void 0;
exports.CACHE_KEY = "TokenServiceInterface.CD";
//# sourceMappingURL=TokenServiceInterface.js.map